/**
 * OB-6 — is Account payment offerable for the booking in hand?
 *
 * SHARED BY WEB AND MOBILE deliberately. The rule is one line, but the DEFAULT is load-bearing and two
 * copies of it would eventually disagree: `company_policy_available` is absent on a response from a
 * server that predates OB-6, and an absent field must read as AVAILABLE. Defaulting the other way
 * would hide Account payment for every customer the moment a client shipped ahead of the API.
 *
 * It answers a different question from `profile.company_policy_allowed`, which is the static
 * permission ("may they, in principle") held in the session. The UI offers Account payment only when
 * BOTH are true, and this half is live, per request, and specific to the month this booking charges —
 * which is why it is read off the reservation and never off the profile store, hydrated once at
 * bootstrap.
 *
 * THIS IS A COURTESY, NEVER A CONTROL. The server gate is authoritative; a client that forgets to
 * check is still refused.
 */
function isAccountPaymentAvailable(reservation) {
    return reservation ? reservation.company_policy_available !== false : true;
}

module.exports = {
    isAccountPaymentAvailable,
};
